<template>
    <v-tab-item :value="TABS.BASIC.value" class="fill-height pa-16">
        <v-layout column justify-center class="h-100 mx-auto" style="max-width: 1224px">
            <v-sheet style="flex: 1 1 auto; overflow-x: hidden; overflow-y: auto" class="scroll-primary pr-10">
                <div class="mb-20 mb-lg-40">
                    <vertical-form-table
                        v-model="form"
                        v-bind="{
                            items,
                            class: 'flex-grow-1',
                        }"
                        @input="emit"
                    />
                    <basic-convert
                        v-model="form"
                        v-bind="{
                            loading,
                        }"
                        v-on="{
                            setLoading,
                            input: emit,
                        }"
                    />
                </div>
            </v-sheet>
            <div class="v-btn-group flex-wrap mt-16">
                <v-btn
                    outlined
                    color="grey-d"
                    class="min-w-140px min-w-lg-160px"
                    v-bind="{
                        loading,
                    }"
                    @click="$emit('exit')"
                >
                    <span class="grey-6--text">취소</span>
                </v-btn>
                <v-btn color="primary" class="min-w-140px min-w-lg-160px" v-bind="{ loading }" @click="next">
                    <span> 다음 단계 </span>
                    <v-icon>mdi-chevron-right</v-icon>
                </v-btn>
            </div>
        </v-layout>
    </v-tab-item>
</template>

<script>
import { attrs_input, initEmploymentForm } from "@/assets/variables";
import { TABS } from "../lib";

import VerticalFormTable from "@/components/dumb/vertical-form-table.vue";
import BasicConvert from "./basic/basic-convert.vue";

const items = [
    {
        key: "name",
        term: "계약서 명칭",
        type: "text",
        required: true,
    },
    {
        key: "file",
        term: "계약서 파일",
        type: "file",
        required: true,
    },
].map((item) => ({ ...attrs_input, ...item }));

export default {
    components: {
        VerticalFormTable,
        BasicConvert,
    },
    props: {
        value: { type: Object, defatul: initEmploymentForm },
        loading: { type: Boolean, default: false },
    },
    data: () => ({
        form: initEmploymentForm(),

        TABS,
        items,
    }),
    mounted() {
        this.sync();
    },
    watch: {
        value() {
            this.sync();
        },
    },
    methods: {
        sync() {
            this.form = initEmploymentForm(this.value);
        },
        emit() {
            this.$emit("input", this.form);
        },
        next() {
            try {
                if (!this.form.name) throw new Error("계약서 명칭을 입력해주세요");
                if (!this.form.file) throw new Error("계약서 파일을 업로드해주세요");

                this.$emit("next");
            } catch (error) {
                alert(error.message);
            }
        },
        setLoading(loading) {
            this.$emit("setLoading", loading);
        },
    },
};
</script>

<style></style>
